import i18next from "../i18n";

export const translate = (key: string, options?: {}): string => {
  const translatedString = i18next.t(key, options);

  if (typeof translatedString !== "string") {
    return "";
  } else {
    return translatedString;
  }
};
